'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reselect = require('reselect');

var _reactRedux = require('react-redux');

var _ProcessingPage = require('../../../../components/loaders/ProcessingPage');

var _ProcessingPage2 = _interopRequireDefault(_ProcessingPage);

var _FlexCenter = require('../../../../components/misc/FlexCenter');

var _FlexCenter2 = _interopRequireDefault(_FlexCenter);

var _PlanTypeDetailSection = require('./planSections/PlanTypeDetailSection');

var _PlanTypeDetailSection2 = _interopRequireDefault(_PlanTypeDetailSection);

var _PlanCardDetailSection = require('./planSections/PlanCardDetailSection');

var _PlanCardDetailSection2 = _interopRequireDefault(_PlanCardDetailSection);

var _PlanStorageDetailSection = require('./planSections/PlanStorageDetailSection');

var _PlanStorageDetailSection2 = _interopRequireDefault(_PlanStorageDetailSection);

var _PlanBillingDetailSection = require('./planSections/PlanBillingDetailSection');

var _PlanBillingDetailSection2 = _interopRequireDefault(_PlanBillingDetailSection);

var _PlanTeamDetailSection = require('./planSections/PlanTeamDetailSection');

var _PlanTeamDetailSection2 = _interopRequireDefault(_PlanTeamDetailSection);

var _PlanCancelSection = require('./planSections/PlanCancelSection');

var _PlanCancelSection2 = _interopRequireDefault(_PlanCancelSection);

var _elementCountSelector = require('../../../elementCount/elementCountSelector');

require('./PlanPro.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countSelector = (0, _reselect.createStructuredSelector)({
    elementCount: _elementCountSelector.contentElementCountSelector
});

var UpgradePlan = function UpgradePlan(props) {
    var subscriptionDetail = props.subscriptionDetail;


    if (!subscriptionDetail) return _react2.default.createElement(_ProcessingPage2.default, null);

    return _react2.default.createElement(
        _FlexCenter2.default,
        null,
        _react2.default.createElement(
            'div',
            { className: 'PlanPro' },
            _react2.default.createElement(_PlanTypeDetailSection2.default, props),
            _react2.default.createElement(_PlanStorageDetailSection2.default, props),
            _react2.default.createElement(_PlanCardDetailSection2.default, props),
            _react2.default.createElement(_PlanBillingDetailSection2.default, props),
            _react2.default.createElement(_PlanTeamDetailSection2.default, props),
            _react2.default.createElement(_PlanCancelSection2.default, props)
        )
    );
};

UpgradePlan.propTypes = {
    subscriptionDetail: _propTypes2.default.object,
    elementCount: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(countSelector)(UpgradePlan);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/pro/PlanPro.js
// module id = 2068
// module chunks = 0